import React, { useState } from "react";
import api from "../../api";
import { useEffect } from "react";
import MarketCapChart from "./marketCapChart";
import FearGreedChart from "./fearAndGreed";
import { EthGaseComp } from "./ethGas";
import { DominanceComp } from "./dominanceComp";
import EtfNetFlowChart from "./etfChart";

export const MarketOverview = () => {
  const baseUrl = `${window.location.protocol}//${window.location.host}`;
  const [loader, setLoader] = useState(false);
  const [topCrypto, setTopCrypto] = useState([
    {
      symbol: "btc",
    },
    {
      symbol: "eth",
    },
    {
      symbol: "bnb",
    },
    {
      symbol: "sol",
    },
    {
      symbol: "xrp",
    },
  ]);
  const [altIndex, setAltIndex] = useState(0);
  const [twentyIndex, setTwentyIndex] = useState(0);
  const [ethGasData, setethGasData] = useState({});
  const [domincanceData, setDomincanceData] = useState({});

  const getTopCrypto = async () => {
    try {
      setLoader(true);
      const resp = await api.getTopCrypto();
      // console.log(resp);
      if (resp?.data) {
        setTopCrypto(resp?.data || []);
      }
    } catch (e) {
      console.log(e.message);
      setLoader(false);
    }
  };

  const getOpenInterest = async () => {
    try {
      setLoader(true);
      const resp = await api.getOpenInterest();
      console.log("open interest");
      console.log(resp);
      if (resp?.data) {
        // setTopCrypto(resp?.data || []);
      }
    } catch (e) {
      console.log(e.message);
      setLoader(false);
    }
  };

  const get20Index = async () => {
    try {
      setLoader(true);
      const resp = await api.get20Index();
      // console.log(resp);
      if (resp?.latest) {
        setTwentyIndex(resp?.latest || []);
      }
    } catch (e) {
      console.log(e.message);
      setLoader(false);
    }
  };

  const getAltSeasonIndex = async () => {
    try {
      setLoader(true);
      const resp = await api.getAltSeasonIndex();
      // console.log(resp);
      if (resp?.altIndex) {
        setAltIndex(resp?.altIndex || 0);
      }
    } catch (e) {
      console.log(e.message);
      setLoader(false);
    }
  };
  const getEthGasData = async () => {
    try {
      setLoader(true);
      const resp = await api.getEthGas();
      // console.log("eth gas");
      // console.log(resp);
      if (resp?.gas) {
        setethGasData(resp?.gas);
      }
    } catch (e) {
      console.log(e.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    getTopCrypto();
    get20Index();
    getAltSeasonIndex();
    // getOpenInterest();
    getEthGasData();
  }, []);

  function formatNumber(num) {
    const isNegative = num < 0;
    const absNum = Math.abs(num);

    let formatted;
    if (absNum >= 1_000_000_000) {
      formatted = (absNum / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
    } else if (absNum >= 1_000_000) {
      formatted = (absNum / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
    } else if (absNum >= 1_000) {
      formatted = (absNum / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
    } else {
      formatted = absNum.toString();
    }

    return isNegative ? `-${formatted}` : formatted;
  }

  const ScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="marketOverviewPage">
      <div className="container">
        <h1 className="heading mb-0">Market Overview</h1>
        <p className="pageDesc mb-4">
          Stay updated on the crypto cycle with real-time Bitcoin dominance,
          Altcoin Season Index, ETF net flows, and market sentiment organized in
          one clean view on our platform.
        </p>
        <div className="row ">
          {topCrypto.map((item, key) => (
            <div className="col-sm-6 mb-3 col-lg-5th" key={key}>
              <div className="lCard">
                <div className="logo">
                  <img
                    src={`${baseUrl}/icon/${item?.symbol.toLowerCase()}.svg`}
                    alt="binance"
                  />
                </div>
                <div className="content">
                  <div className="title">{item?.name}</div>
                  <div className="price">
                    ${item?.price ? item?.price.toFixed(2) : 0}
                  </div>
                  <div
                    className={
                      item?.percent_change_24h < 0
                        ? "priceChange color-red"
                        : "priceChange color-green"
                    }
                  >
                    <span className="color-dark">24H: </span>
                    {item?.percent_change_24h
                      ? item?.percent_change_24h.toFixed(2)
                      : 0}
                    %
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="row">
          <div className="col-lg-4">
            <div className="mCard grayCard mb-3">
              <div className="title">Altcoin Season Index</div>
              <div className="outOf">
                <span>{altIndex}</span> / 100
              </div>
              <div className="altIndexTitle">
                <div>Bitcoin Season</div>
                <div>Altcoin Season</div>
              </div>
              <div className="altIndicatorM">
                <div className="col1"></div>
                <div className="col2"></div>
                <div className="col3"></div>
                <div className="col4"></div>
                <div className="pointer" style={{ left: `${altIndex}%` }}></div>
              </div>
            </div>
            <div className="mCard grayCard mb-3">
              <div className="title">20 Index</div>
              <div className="outOf">
                <span>${twentyIndex}</span>
              </div>
            </div>
            <div className="mCard grayCard mb-3">
              <div className="title">Fear and Greed Index</div>

              <FearGreedChart />
            </div>
          </div>
          <div className="col-lg-8">
            <MarketCapChart setDomincanceData={setDomincanceData} />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-8">
            <EtfNetFlowChart />
          </div>
          <div className="col-lg-4">
            <EthGaseComp ethGasData={ethGasData} />
            <DominanceComp domincanceData={domincanceData} />
          </div>
        </div>
      </div>
      <div className="scrollTopTop" onClick={ScrollToTop}>
        <i className="fa-solid fa-arrow-up-long"></i>
      </div>
    </div>
  );
};
